import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PendingSubmissions = ({ submissions, onApprove, onReject }) => {
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
              Pending Submissions
            </h3>
            <p className="text-sm text-muted-foreground">
              {submissions?.length} submissions awaiting review
            </p>
          </div>
          <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
            <Icon name="Clock" size={20} className="text-warning" />
          </div>
        </div>
      </div>
      <div className="divide-y divide-border max-h-[600px] overflow-y-auto scrollbar-custom">
        {submissions?.map((submission) => (
          <div key={submission?.id} className="p-4 md:p-6 hover:bg-muted/30 transition-colors">
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                    src={submission?.influencerAvatar}
                    alt={submission?.influencerAvatarAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="text-sm font-semibold text-foreground truncate">
                      {submission?.influencerName}
                    </p>
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary flex-shrink-0">
                      Score: {submission?.influencerScore}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">
                    @{submission?.influencerHandle} • {submission?.submittedAt}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-3">
                    <div className="flex items-center gap-1 text-xs text-muted-foreground">
                      <Icon name="ShoppingBag" size={14} />
                      <span className="data-text">${submission?.purchaseAmount?.toFixed(2)}</span>
                    </div>
                    <div className="flex items-center gap-1 text-xs text-muted-foreground">
                      <Icon name="Tag" size={14} />
                      <span>{submission?.campaign}</span>
                    </div>
                    <div className="flex items-center gap-1 text-xs text-muted-foreground">
                      <Icon name="Heart" size={14} />
                      <span className="data-text">{submission?.postEngagement?.toLocaleString()} engagements</span>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <a
                      href={submission?.receiptUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-muted hover:bg-muted/80 text-xs font-medium text-foreground transition-colors"
                    >
                      <Icon name="FileText" size={14} />
                      View Receipt
                    </a>
                    <a
                      href={submission?.postUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-muted hover:bg-muted/80 text-xs font-medium text-foreground transition-colors"
                    >
                      <Icon name="ExternalLink" size={14} />
                      View Post
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex lg:flex-col gap-2 lg:w-32 flex-shrink-0">
                <Button
                  variant="success"
                  size="sm"
                  iconName="Check"
                  onClick={() => onApprove(submission?.id)}
                  fullWidth
                >
                  Approve
                </Button>
                <Button
                  variant="destructive"
                  size="sm"
                  iconName="X"
                  onClick={() => onReject(submission?.id)}
                  fullWidth
                >
                  Reject
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingSubmissions;